module.exports = __webpack_public_path__ + "img/windows_logo.ad9de0fa.svg";